import e from"styled-components";import o from"react";import t from"prop-types";import{calculateRem as i}from"@vds-core/utilities";import{TypographyTokens as r}from"@vds-tokens/typography";import{ColorTokens as n}from"@vds-tokens/color";import{Fonts as a}from"@vds-core/typography";const l={children:t.oneOfType([t.string,t.array,t.node]),surface:t.oneOf(["light","dark"])},s=e.div.withConfig({displayName:"StyledModalBody",componentId:"VDS__sc-o9hn4k-0"})`
  flex: 1 0 auto;
  color: ${({surface:e})=>"dark"===e?n.elements.primary.ondark.value:n.elements.primary.onlight.value};
  line-height: ${i(r.lineheight.body[20].value)};
  font-size: ${i(r.fontsize.body[16].value)};
  letter-spacing: ${i(r.letterspacing.wide.value)};
  font-family: ${a.VerizonNHGeDS};
  padding: ${i(24)} 0 0 0;
  position: relative;
  &:active {
    outline: none;
  }

  @media (min-width: 767px) {
    line-height: ${i(r.lineheight.body[20].value)};
    font-size: ${i(r.fontsize.body[16].value)};
    font-family: ${a.VerizonNHGeDS};
  }
`,d=e=>{const{children:t,surface:i}=e;return o.createElement(s,{surface:i,"data-testid":"modal-body"},t)};d.propTypes=l,d.defaultProps={surface:"light"};export{d as default};
